const makeId = (arg1, arg2) =>
  `${String(arg1)}-${String(arg2).split(' ').join('-')}`

export default makeId
